import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManualAccessComponent } from './manual-access.component'; 
import { manualdataaccessRoutingModule } from './manualdataaccess-routing.module';



@NgModule({
  declarations: [ManualAccessComponent],
  imports: [
    CommonModule,manualdataaccessRoutingModule
  ]
})
export class ManualAccessModule { }
